import { ComponentProps } from 'react';
import { NavLink } from 'react-router-dom';
import { Flex, FlexProps, forwardRef } from '@chakra-ui/react';

export const AnimatedLinkContainer = forwardRef<
  FlexProps & {
    isActive: boolean;
    disabled?: boolean;
  },
  typeof NavLink
>(({ children, isActive, ...props }) => (
  <Flex
    _before={{
      backgroundColor: isActive ? 'grey.800' : undefined,
      content: '""',
      height: '100%',
      left: 0,
      position: 'absolute',
      top: 0,
      width: '2px',
    }}
    _disabled={{
      opacity: 0.5,
      pointerEvents: 'none',
    }}
    _hover={
      !isActive
        ? {
            '&:before': {
              backgroundColor: 'grey.400',
            },
            backgroundColor: 'grey.200',
          }
        : undefined
    }
    alignItems="center"
    as={props.disabled ? 'div' : NavLink}
    backgroundColor={isActive ? 'grey.200' : undefined}
    exact
    paddingY="space-8"
    position="relative"
    {...props}
  >
    {children}
  </Flex>
));

export type AnimatedLinkContainerProps = ComponentProps<
  typeof AnimatedLinkContainer
>;
